(function (Drupal) {
  Drupal.behaviors.lightboxHoverZoom = {
    attach(context) {

      const dialog = document.getElementById('lightbox');
      const img = document.getElementById('lightbox-img');

      if (!dialog || !img) return;

      // --- Abrir Lightbox ---
      context.querySelectorAll('.gallery__img').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          img.src = thumb.dataset.full;
          resetZoom();
          dialog.showModal();
        });
      });

      // --- Cerrar al hacer clic fuera ---
      dialog.addEventListener('click', (e) => {
        if (e.target === dialog) {
          dialog.close();
        }
      });

      // --- Zoom suave al mover el mouse ---
      img.addEventListener('mousemove', (e) => {
        const rect = img.getBoundingClientRect();

        // Coordenadas relativas dentro de la imagen
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;

        img.style.transformOrigin = `${x}% ${y}%`;
        img.style.transform = 'scale(2)';
      });

      // --- Reset cuando se sale con el mouse ---
      img.addEventListener('mouseleave', () => {
        resetZoom();
      });

      function resetZoom() {
        img.style.transform = 'scale(1)';
        img.style.transformOrigin = 'center center';
      }
    }
  };
})(Drupal);
